<template lang="html">

  <div class="wrapper -conectados">

    <div class="encabezado">
      <div class="container column-start">
        <div class="contenedor-logo">
          <img src="/static/img/UFV-logo.png" alt="Logo UFV">
        </div>
        <h1 v-if="$route.name == 'ficha-noticia'">Al día</h1>
        <h1 v-if="$route.name == 'ficha-evento'">Eventos</h1>
        <h1 v-if="$route.name == 'ficha-recurso'">Recursos</h1>
      </div>
    </div>


    <div class="migas">
      <div class="container">
        <nav class="row-start">
          <router-link to="/">Home</router-link>
          <template v-if="$route.name == 'ficha-recurso'">
            <router-link :to="$t('enlaces.alumnos')">Alumnos y alumni</router-link>
            <router-link :to="$t('enlaces.orientacion')">Orientación</router-link>
            <router-link :to="$t('enlaces.buscadorrecursos')">Buscador de recursos</router-link>
          </template>

          <router-link v-if="$route.name == 'ficha-evento' || $route.name == 'ficha-noticia'" :to="$t('enlaces.aldia')">Al día</router-link>

          <a v-if="data">{{data.titulo}}</a>

        </nav>

      </div>
    </div>

    <section class="ficha-noticia">

      <template v-if="!!data">

        <h1 v-html="data.titulo"></h1>

        <h3 class="fecha">{{data.fecha.day}} de {{$t(`meses[${data.fecha.month-1}]`)}} {{data.fecha.year}}</h3>

        <h3 class="location" v-if="!!data.localizacion">{{data.localizacion}}</h3>

        <div class="imagen-intro">
          <img :src="data.img.url" :alt="data.titulo">
        </div>




        <h2 v-html="data.entradilla"></h2>



        <!-- MODULOS -->
        <template v-for="el in data.modulos">

          <div v-if="el.tipo =='texto'" class="parrafo">
            <p v-html="el.texto"></p>
          </div>

          <div class="contenedor-imagen" v-if="el.tipo == 'imagen'">

            <img :src="el.enlace" v-if="el.tipo == 'imagen'" class="img-full">
            <span v-html="el.pie" v-if="el.tipo == 'imagen'" class="pie"></span>

          </div>

          <h4 :nivel="el.nivel" v-if="el.tipo == 'destacado'" class="destacado" v-html="el.texto"></h4>

          <h2 v-if="el.tipo == 'titulo'" class="title--sup -green-line -black" v-html="el.value"></h2>

          <object :data="$options.filters.urlToID(el.enlace)" v-if="el.tipo == 'video'">
          </object>

          <div class="contenedor-link row-center" v-if="el.tipo == 'link'">

            <div class="link row-start">
              <a :href="el.enlace" class="enlace-cover" rel="noopener" target="_blank"></a>
              <img v-if="!!el.meta.image" :src="el.meta.image.url" alt="">
              <h2>{{el.meta.title}}</h2>
              <p>{{el.meta.description}}</p>
            </div>

          </div>

          <div class="descargable row-center" v-if="el.tipo == 'file'">
            <a :href="el.enlace" class="enlace-cover" rel="noopener" target="_blank"></a>
            <span class="icon"></span>
            <p v-if="!!el.meta.name">{{el.meta.name}}</p>
          </div>

          <ul v-if="el.tipo == 'lista' && el.estilo == 'unordered'">
            <li v-for="el in el.objectos" v-html="el"></li>
          </ul>

          <ol v-if="el.tipo == 'lista' && el.estilo == 'ordered'">
            <li v-for="el in el.objectos" v-html="el"></li>
          </ol>

        </template>

        <!-- DESCARGABLE -->

        <template v-if='!!data.descargable'>

          <div class="contenedor-descarga row-between">
            <h6 v-html="data.descargable.pie"></h6>
            <a v-if='!!data.descargable.enlace' :href="getServer+data.descargable.enlace" target="_blank"
              class="download"></a>
          </div>

        </template>

        <!-- //DESCARGABLE//-->

        <a v-if="!!data.url" :href="data.url" class="btn -fill">Ver más</a>

      </template>

      <!-- FIN DE LA FICHA -->

    </section>

  </div>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex'

  import fichaFake from '@/components/view-parts/actualidad/ficha-fake'

  export default {
    name: 'ficha-noticia',
    props: [],
    created() {

      if (this.$route.name == 'ficha-noticia') {
        this.getNoticia();
      } else if (this.$route.name == 'ficha-evento') {
        this.getEvento();
      } else if (this.$route.name == 'ficha-recurso') {
        this.getRecurso();
      }

    },
    data() {
      return {
        data: ''
      }
    },
    methods: {
      ...mapActions(['requestNoticia', 'requestEvento', 'requestRecurso']),
      getNoticia() {
        this.requestNoticia(this.$route.params.id)
          .then((result) => {
            this.data = result;
          })
      },
      getEvento() {
        this.requestEvento(this.$route.params.id)
          .then((result) => {
            this.data = result;
          })
      },
      getRecurso() {
        this.requestRecurso(this.$route.params.id)
          .then((result) => {
            this.data = result;
          })
      }
    },
    computed: {
      ...mapGetters(['getServer'])
    },
    components: {
      'ficha-fake': fichaFake
    },
    filters: {
      urlToID(value) {

        let string;

        console.log(value);

        if (value.includes('youtube')) {
          string = 'https://youtube.com/embed/' + value.split("?v=")[1];
        } else if (value.includes('vimeo')) {
          string = 'https://player.vimeo.com/video/' + value.split("/").pop();
        }

        return string;
      }
    },
    watch: {
      '$route'() {
        this.getNoticia();
      }
    }
  }
</script>

<style scoped lang="scss">
  .ficha-noticia {}
</style>


// WEBPACK FOOTER //
// src/components/views/ficha-noticia.vue